import React from "react";

import { ROUTES } from "./screens";

import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";

const NAV_LIST_DEFAULT = [
  {
    label: "Items",
    path: ROUTES.ASSETS,
  },
  {
    label: "Activities",
    path: ROUTES.ACTIVITIES,
  },
  {
    label: "Projects",
    path: ROUTES.PROJECTS,
  },
  {
    label: "Vendors",
    path: ROUTES.VENDORS,
  },
];

const NAV_LIST_BUSINESS = [
  {
    label: "Visits",
    path: ROUTES.VISITS,
    icon: <FlagOutlinedIcon />,
  },
  {
    label: "Customers",
    path: ROUTES.CUSTOMERS,
    icon: <PeopleAltOutlinedIcon />,
  },
];

export const NAV_LIST = {
  default: NAV_LIST_DEFAULT,
  business: NAV_LIST_BUSINESS,
};

// Lands on the first admin page; ActiveClassNavLink keeps it highlighted across /admin/*.
export const ADMIN_NAV_ITEM = { label: "Admin", path: ROUTES.ADMIN };

/** Adds the Admin item for admins only. The API refuses the admin pages to everyone else whatever the menu shows. */
export const withAdminNavItem = <T extends { label: string; path: string }>(
  list: T[],
  isAdmin: boolean,
): (T | typeof ADMIN_NAV_ITEM)[] => (isAdmin ? [...list, ADMIN_NAV_ITEM] : list);
